import { restApi } from 'apis'
import { Store } from 'models'
import { CreateDeliveryQuoteRequest } from 'models/CreateDeliveryQuoteRequest'
import { DeliveryQuote } from 'models/DeliveryQuote'
import { LoadStoreRequest } from 'models/LoadStoreRequest'
import { SubmitOrderRequest } from 'models/SubmitOrderRequest'
import { SubmitOrderResponse } from 'models/SubmitOrderResponse'

const storeApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    loadStore: builder.query<Store, LoadStoreRequest>({
      query: ({ storeId, tableId }) => ({
        url: `/app/ordering/${storeId}`,
        params: { tableId },
      }),
    }),
    postOrder: builder.mutation<SubmitOrderResponse, SubmitOrderRequest>({
      query: ({ storeId, submitToken, order }) => ({
        url: `/app/ordering/${storeId}/order`,
        method: 'POST',
        body: order,
        headers: {
          'X-Request-Recaptcha-Token': submitToken,
        },
      }),
    }),
    getDeliveryQuote: builder.query<DeliveryQuote, CreateDeliveryQuoteRequest>({
      query: (params) => ({
        url: `/delivery/${params.storeid}/quote`,
        params,
      }),
    }),
  }),
})

export const {
  useLazyLoadStoreQuery,
  useLoadStoreQuery,
  usePostOrderMutation,
  useLazyGetDeliveryQuoteQuery,
} = storeApi
